export const HYPE = [
    'Software Engineering',
    'UX/UI Testing and Development',
    'System Analysis and Project Management',
    'Data Analysis and Visualization',
    'Machine Learning'
];


// WEBPACK FOOTER //
// ./src/components/Home/constants.js